/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useState }                      from 'react'
import Box                                      from "@material-ui/core/Box"
import Grid                                     from "@material-ui/core/Grid"
import GuestBioUpdateComponent                  from '../Components/GuestBioUpdateComponent'
import HistoryCitationUpdateComponent           from '../Components/HistoryCitationUpdateComponent'
import HistoryUpdateComponent                   from '../Components/HistoryUpdateComponent'
import PilotCohortSourceUpdateComponent         from '../Components/PilotCohortSourceUpdateComponent'
import RadioOptionComponent                     from '../Components/RadioOptionComponent'
import { historyEntryTypeRadioOptions }         from '../config'
import Typography                               from '@material-ui/core/Typography'

const HistoryUpdatePage = () => {

   const [ guestBioEntry,                       setGuestBioEntry                 ]  =  useState(false)
   const [ historyCitation,                     setHistoryCitation               ]  =  useState(false)
   const [ historyEntry,                        setHistoryEntry                  ]  =  useState(false)
   const [ pilotCohortSourceTableEntry,         setPilotCohortSourceTableEntry   ]  =  useState(false)

   const getOption = (o) => {
      switch (o) {
         case 'Guest Bio Entry':
            setGuestBioEntry(true)
         break
         case 'History Citation':
            setHistoryCitation(true)
         break
         case 'History Entry':
            setHistoryEntry(true)
         break
         case 'Pilot / Cohort / Source Table':
            setPilotCohortSourceTableEntry(true)
         break
      }
   }

   return (
      <Box>
         {guestBioEntry || historyEntry || historyCitation || pilotCohortSourceTableEntry
            ?
               null
            :
               <Grid style={{ marginTop: '6rem' }} >
                  <Typography variant='h4' >
                     Update Page
                  </Typography>
                  <RadioOptionComponent getOption={getOption} options={historyEntryTypeRadioOptions} />
               </Grid>
         }
         {guestBioEntry                ?  <GuestBioUpdateComponent />            :  null}
         {historyCitation              ?  <HistoryCitationUpdateComponent />     :  null}
         {historyEntry                 ?  <HistoryUpdateComponent />             :  null}
         {pilotCohortSourceTableEntry  ?  <PilotCohortSourceUpdateComponent />   :  null}
      </Box>
   )
}

export default HistoryUpdatePage
